import axios from "axios";
import { store } from "../core/data/redux/store";
import { logout } from "../core/data/redux/userSlice";

// Create an Axios instance
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // Set your API URL here
  timeout: 60000, // Timeout for API requests
});

// Request Interceptor: Adds Authorization token if available in localStorage
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); // Get the token from localStorage
    const guestToken = localStorage.getItem("guest_token");
    if (token) {
      config.headers["authorization"] = `${token}`; // Attach the token
    }
    if (guestToken) {
      config.headers["guest-access-token"] = `Bearer ${guestToken}`;
    }
    // If the data is FormData, remove the Content-Type header
    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    } else {
      // Set Content-Type to application/json for regular JSON data
      config.headers["Content-Type"] = "application/json";
    }
    return config; // Proceed with the request
  },
  (error) => {
    return Promise.reject(error); // Reject the request if there is an error
  },
);

// Response Interceptor: Global error handling
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status = error.response?.status;

    const requestHeaders = error.config?.headers ?? {};
    const isGuestRequest =
      !!requestHeaders["guest-access-token"] &&
      !requestHeaders["authorization"];

    if (isGuestRequest) {
      return Promise.reject(error.response ?? error);
    }

    if (status === 401) {
      store.dispatch(logout());
      window.location.href = "/login";
      return Promise.reject(error.response ?? error);
    }

    return Promise.reject(error.response ?? error);
  },
);

export default api;
